 const cartActionTypes = {
    TOGGLE_CART_HIDDEN:'TOGGLE_CART_HIDDEN',
    ADD_ITEMS:'ADD_ITEMS',
    REMOVE_ITEM:'REMOVE_ITEM',
    CLEAR_ITEM_FROM_CART:' CLEAR_ITEM_FROM_CART',
    EMPTY_CART:'EMPTY_CART'
}
export default cartActionTypes; 